<template>
  <b-form @submit.prevent="$emit('submit')">

    <!-- device -->
    <b-form-group :label="$t('Device')" label-for="device" :state="null">
      <v-select v-model="form.device_id" label="name" :reduce="val => val.device_id"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="devicesOptions" :clearable="true"
                input-id="device" @input="set_name($event), filterAreas()" />
      <b-form-invalid-feedback v-if="errors && ('device_id' in errors)"
                               :state="errors && ('device_id' in errors) ? false : null">
        {{ $t(errors.device_id[0]) }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group :label="$t('Name')" label-for="name">
      <b-form-input id="name" v-model="form.name" autofocus :state="errors && ('name' in errors) ? false : null"
                    trim autocomplete="off" placeholder="" />
      <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="errors && ('name' in errors) ? false : null">
        {{ $t(errors.name[0]) }}
      </b-form-invalid-feedback>
    </b-form-group>


    <b-row>
      <b-col md="6" xl="4" sm="12">
        <b-form-group :label="$t('Camp')" label-for="camp" :state="null">
          <v-select v-model="form.camp_id" label="name" :reduce="val => val.geofence_id"
                    :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="campsOption" :clearable="false"
                    input-id="camp" />
          <b-form-invalid-feedback v-if="errors && ('camp_id' in errors)"
                                   :state="errors && ('camp_id' in errors) ? false : null">
            {{ $t(errors.camp_id[0]) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col md="6" xl="4" sm="12">
        <b-form-group :label="$t('landfills')" label-for="landfill" :state="null">

          <v-select v-model="form.landfills" label="name" multiple :close-on-select="false"
                    :reduce="val => val.geofence_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                    :options="landFillAreasOption" :clearable="false" input-id="landfill" if />
          <b-form-invalid-feedback v-if="errors && ('landfills' in errors)"
                                   :state="errors && ('landfills' in errors) ? false : null">
            {{ $t(errors.landfills[0]) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>


      <b-col cols="6" xl="2">
        <!-- leave camp time -->
        <b-form-group :label="$t('Leave Camp Time')" label-for="leave-camp" :state="null">
          <flat-pickr v-model="form.camp_leave" dateFormat="H:m:s" class="form-control"
                      :class="{ 'is-invalid': errors && ('camp_leave' in errors) }" :config="timePickerConfig"
                      placeholder="HH:MM:SS" />
          <b-form-invalid-feedback v-if="errors && ('camp_leave' in errors)"
                                   :state="errors && ('camp_leave' in errors) ? false : null">
            {{ $t(errors.camp_leave[0]) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="6" xl="2">
        <!-- back camp time -->
        <b-form-group :label="$t('Back Camp Time')" label-for="back-camp" :state="null">
          <flat-pickr v-model="form.camp_back" :state="null" class="form-control"
                      :class="{ 'is-invalid': errors && ('camp_back' in errors) }" :config="timePickerConfig"
                      placeholder="HH:MM:SS" />
          <b-form-invalid-feedback v-if="errors && ('camp_back' in errors)"
                                   :state="errors && ('camp_back' in errors) ? false : null">
            {{ $t(errors.camp_back[0]) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <schedule-form-repeater :items.sync="rows" :errors="errors"
                                :workAreasOptions="workAreasOptions" :week_ordinaries="week_ordinaries" :week_days="week_days">
        </schedule-form-repeater>
      </b-col>
    </b-row>

      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
          {{ $t('Save') }}
        </b-button>
      </div>
    </b-form>
</template>

<script>

import {
  BCol, BRow, BFormGroup, BFormInvalidFeedback, BFormRadioGroup, BFormCheckboxGroup,
  BButton, BForm, BFormInput, BFormSelect, BFormSelectOption,BFormFile

} from 'bootstrap-vue'

import { onUnmounted, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@/libs/axios'
import ScheduleFormRepeater from '@/views/modules/plans/washer-plan/share/ScheduleFormRepeater.vue'
import { common } from '@/api/common'
import { apiService } from '@/api/api'
import boolean from 'vue-good-table/src/components/types/boolean'

export default {
  components: {
    ScheduleFormRepeater,
    BFormFile, BButton, BFormCheckboxGroup,
    flatPickr, vSelect, BForm, BFormInput,
    BCol, BRow, BFormGroup, BFormInvalidFeedback, BFormRadioGroup, BFormSelect, BFormSelectOption
  },
  props: {
    form: Object,
    rows: Array,
    errors: Object,
    indicator: boolean
  },
  directives: {
    Ripple,
  },
  setup(props, {emit}) {

    const { week_days, week_ordinaries, timePickerConfig } = common()
    const { getLinked, filterOptions } = apiService()

    const importFileInput = ref(null)
    const user = store.getters['auth/user']
    const device_geofences_ids = ref()

    const devicesOptions = ref([])
    const workAreasOptions = ref([])
    const campsOption = ref([])
    const campsOption_org = ref([])
    const workAreasOptions_org = ref([])
    const landFillAreasOption = ref([])

    const downloadTemplate = ()=> {
      axios.get('import/template', {params:{ model: 'rfidDumpPlanContainers'}, responseType: 'blob'})
          .then( res => {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'], encoding: 'UTF-8' }))
            link.download = 'containers-import-template.xlsx'
            link.click()
          }).catch( err => console.log(err))
    }

    const setOptions = area => {
      switch (area.category) {
        case 'WORK_AREA': workAreasOptions.value.push(area); break
        case 'CAMP_AREA': campsOption.value.push(area); break
        case 'LANDFILL_AREA':landFillAreasOption.value.push(area);break
      }
    }

    const set_name = (e) => {
      const device = devicesOptions.value.find(d => d.device_id === e)
      // props.planData.name += ` - ${device.name}`
      // props.planData.device_id = device.device_id
    }

    const setOriginalOptions = area => {
      switch (area.category) {
        case 'WORK_AREA': workAreasOptions_org.value.push(area); break
        case 'CAMP_AREA': campsOption_org.value.push(area); break
      }
    }

    const filterAreas = () => {
      let d_id = props.form.device_id
      device_geofences_ids.value = []
      filterOptions({ deviceId: d_id, type: 'deviceGeofences', }).then(res => {
        //display areas that link to selected device
        device_geofences_ids.value = res.data.ids;

        workAreasOptions.value = workAreasOptions_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
        campsOption.value = campsOption_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
      })
    }

    emit('update:indicator', true)


    Promise.all([

      getLinked({
        user: user.id,
        type: 'geofence',
        cols: 'geofence_id,name,category',
        categoryOrType: {
          categories: 'LANDFILL_AREA,CAMP_AREA',
          types: 'WORK_AREA'
        }
      }).then(res => {
        res.data.data.map(a => {
          setOptions(a)
          setOriginalOptions(a)
        })
      }),

      getLinked({
        user: user.id,
        type: 'device',
        cols: 'device_id,name',
        category: 'CONTAINER_WASHING_TRUCK',
        isSupport: false,
      }).then(res => devicesOptions.value = res.data.data)

    ]).finally( r => {
      console.log('loading data finish..')
      emit('update:indicator', false)
    })



    const importFile = () => {
      props.form.containers_file = importFileInput.value.files[0];
    }

    return {

      week_days,
      week_ordinaries,
      timePickerConfig,

      devicesOptions,

      workAreasOptions,
      landFillAreasOption,
      campsOption,
      device_geofences_ids,
      set_name,
      filterAreas,
      importFileInput,
      importFile,
      downloadTemplate

    }

  }
}
</script>

<style scoped>

</style>
